import { useMutation } from '@tanstack/vue-query';
import { dscvrIcApi } from '@/shared/api';
import type { Principal } from '@dfinity/principal';

export const useRemoveUserAgentMutation = () => {
  return useMutation({
    mutationKey: ['remove-user-agent-mutation'],
    mutationFn: (params: { agentPrincipal: Principal }) =>
      dscvrIcApi.userSettings.removeUserAgent(params.agentPrincipal),
  });
};
